import { processListingParams } from '@/api/helpers';
import { ListingRequest } from '@/api/types';
import { getExceptionFromAxiosError } from '@/client/helpers';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { GetCampaignRequest } from './types';
import {
  ListMasterTemplateUserResultsResponse,
  MasterTemplateReport,
} from './types/master-template-report.type';

export const masterTemplateReportsService = (client: AxiosInstance) => {
  const getBaseUrl = (accountId: string, masterTemplateId: string) =>
    `/gophish/accounts/${accountId}/master-template-reports/${masterTemplateId}`;

  const getReport = async (
    accountId: string,
    masterTemplateId: string,
    params: GetCampaignRequest = {},
  ): Promise<MasterTemplateReport> => {
    try {
      const result = await client.get<
        MasterTemplateReport,
        AxiosResponse<MasterTemplateReport>
      >(getBaseUrl(accountId, masterTemplateId), {
        withCredentials: true,
        params: processListingParams(params),
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getUserResults = async (
    accountId: string,
    masterTemplateId: string,
    params: ListingRequest,
  ): Promise<ListMasterTemplateUserResultsResponse> => {
    try {
      const result = await client.get<
        ListMasterTemplateUserResultsResponse,
        AxiosResponse<ListMasterTemplateUserResultsResponse>
      >(`${getBaseUrl(accountId, masterTemplateId)}/results`, {
        withCredentials: true,
        params: processListingParams(params),
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return {
    getReport,
    getUserResults,
  };
};
